import React from 'react';
import { Box, useTheme } from '@mui/material';
import { RevampedIcon, RevampedIconSize } from '../../../RevampedIcon';

const FILE_TYPE_COLOURS: Record<string, string> = {
  img: 'BRAND',
  jpg: 'BRAND',
  jpeg: 'BRAND',
  png: 'BRAND',
  tiff: 'BRAND',
  gif: 'BRAND',
  svg: 'BRAND',
  eps: 'BRAND',
  webp: 'BRAND',
  pdf: '#D92D20',
  doc: '#155EEF',
  docx: '#155EEF',
  txt: '#475467',
  csv: '#079455',
  xls: '#079455',
  xlsx: '#079455',
  ppt: '#E62E05',
  pptx: '#E62E05',
  mp3: '#DD2590',
  wav: '#DD2590',
  mp4: '#155EEF',
  mpeg: '#155EEF',
  avi: '#155EEF',
  mkv: '#155EEF',
  html: '#444CE7',
  css: '#444CE7',
  rss: '#444CE7',
  sql: '#444CE7',
  js: '#444CE7',
  json: '#444CE7',
  java: '#444CE7',
  xml: '#444CE7',
  exe: '#444CE7',
  dmg: '#444CE7',
  zip: '#344054',
  rar: '#344054',
} as const;

export interface UploaderFileItemIconProps {
  /**
   * The file's type/extension (e.g. "jpeg", "pdf"), used to colour and label the icon
   */
  fileType: string | undefined | null;
}

export const UploaderFileItemIcon = ({ fileType }: UploaderFileItemIconProps) => {
  const {
    palette: { primary },
  } = useTheme();
  const fileTypeKey = fileType?.toLowerCase();
  const fileTypeColour = fileTypeKey ? FILE_TYPE_COLOURS[fileTypeKey] : undefined;

  return (
    <RevampedIcon
      fullPath="/media/icons/design-system/file-upload/generic-file-icon/32px.svg"
      iconSize={RevampedIconSize.XXL}
      additionalContent={
        fileTypeColour && (
          <Box
            sx={{
              height: 'fit-content',
              backgroundColor: fileTypeColour === 'BRAND' ? primary.main : fileTypeColour,
              color: '#FFF',
              padding: '2px 3px',
              fontSize: '10px',
              fontWeight: 700,
              position: 'absolute',
              top: '16px',
              left: '0px',
              lineHeight: '10px',
              borderRadius: '2px',
            }}
          >
            {fileType?.toUpperCase()}
          </Box>
        )
      }
    />
  );
};
